import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

import BadgeSelect2 from '_components/atomic/controls/BadgeSelect2';

const BadgeSelect2Field = ({
  name,
  control,
  rules = {},
  feedback,
  ...restProps
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { ref, ...restField },
        fieldState: { error },
        formState: { isSubmitted },
      }) => (
        <BadgeSelect2
          {...restProps}
          {...restField}
          valid={isSubmitted && !error}
          invalid={isSubmitted && error}
          feedback={error?.message || feedback}
        />
      )}
    />
  );
};

BadgeSelect2Field.propTypes = {
  name: PropTypes.string,
  control: PropTypes.object,
  rules: PropTypes.object,
  feedback: PropTypes.node,
};

export default BadgeSelect2Field;
